/* eslint-disable */
import React, { useState, useRef, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import Statistics from "../../components/Statistics";
import "./styles.scss";

// Debounce utility function
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const Dashboard = () => {
  const containerRef = useRef(null);
  const SCROLL_STORAGE_KEY = 'dashboard-scroll-x';

  // Debounced scroll handler to avoid excessive localStorage writes
  const saveScrollPosition = useCallback(
    debounce((scrollLeft) => {
      try {
        localStorage.setItem(SCROLL_STORAGE_KEY, scrollLeft.toString());
      } catch (error) {
        console.warn('Failed to save scroll position to localStorage:', error);
      }
    }, 200),
    []
  );

  // Handle scroll events
  const handleScroll = useCallback((e) => {
    saveScrollPosition(e.target.scrollLeft);
  }, [saveScrollPosition]);

  // Restore scroll position on mount
  useEffect(() => {
    const restoreScrollPosition = () => {
      try {
        const savedScrollPosition = localStorage.getItem(SCROLL_STORAGE_KEY);
        if (savedScrollPosition && containerRef.current) {
          const scrollLeft = parseInt(savedScrollPosition, 10);
          if (!isNaN(scrollLeft)) {
            // Use requestAnimationFrame to ensure DOM is ready
            requestAnimationFrame(() => {
              if (containerRef.current) {
                containerRef.current.scrollLeft = scrollLeft;
              }
            });
          }
        }
      } catch (error) {
        console.warn('Failed to restore scroll position from localStorage:', error);
      }
    };

    // Restore position after a short delay to ensure content is loaded
    const timeoutId = setTimeout(restoreScrollPosition, 100);

    return () => clearTimeout(timeoutId);
  }, []);

  // Add scroll event listener
  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll, { passive: true });
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, [handleScroll]);

  return (
    <div 
      className="screen-statistics-container row" 
      ref={containerRef}
    >
      <div className="col">
        <Statistics.Sessions />
      </div>
      
      <div className="col">
        <Statistics.Registrations />
      </div>
      <div className="col">
        <Statistics.Properties />
      </div>
      <div className="col">
        <Statistics.Communities />
      </div>
      <div className="col">
        <Statistics.Subscriptions />
      </div>
      
      <div className="col">
        <Statistics.AppSessions />
      </div>
      
      <div className="col">
        <Statistics.AppGrowth />
      </div>
      <div className="col">
        <Statistics.MostActiveUsers />
      </div>
      <div className="col" style={{minWidth:"30vw"}}>
        <Statistics.Notifications />
      </div>
    </div>
  );
};

export default Dashboard;
